var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content-parent"}},[_c('div',{staticClass:"catalog__content-parent"},[_vm._t("default")],2),_c('ui-limit-pagination',{attrs:{"pagination":_vm.pagination},on:{"input":_vm.handlePaginate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }